import SmoothScrollWrapper from "./components/SmoothScrollWrapper";
import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "./components/Layout";
import Home from "./components/Pages/Home";
import About from "./components/Pages/About";
import Blog from "./components/Pages/Blog";
import Appointments from "./components/Pages/Appointments";
// import Departments from "./components/Pages/Departments";
import DepartmentDetails from "./components/Pages/DepartmentDetails";
import BlogDetails from "./components/Pages/BlogDetails";
import DoctorDetails from "./components/Pages/DoctorDetails";
// import PricingPlan from "./components/Pages/PricingPlan";
import Gallery from "./components/Pages/Gallery";
// import Timetable from "./components/Pages/Timetable";
import Contact from "./components/Pages/Contact";
import ErrorPage from "./components/Pages/ErrorPage";
import Solution from "./components/Pages/Solution.jsx";
import Querise from "./components/Pages/Querise.jsx";
import Review from "./components/Pages/Review.jsx";
import ModalComponent from "./components/popup/ModalComponent";
import CompleteWorkup from "./components/FertilityServices/CompleteWorkup.jsx";
import Counselling from "./components/FertilityServices/Counselling.jsx";
import EggOrSpermDonation from "./components/FertilityServices/EggOrSpermDonation.jsx";
import EmbryoDonation from "./components/FertilityServices/EmbryoDonation.jsx";
import FertilityPreservation from "./components/FertilityServices/FertilityPreservation.jsx";
import Laparoscopy from "./components/FertilityServices/Laparoscopy.jsx";
import ICSI from "./components/FertilityServices/ICSI.jsx";
import IUI from "./components/FertilityServices/IUI.jsx";
import IVF from "./components/FertilityServices/IVF.jsx";
import LaparoscopyRemoval from "./components/FertilityServices/LaparoscopyRemoval.jsx";
import TesaPesa from "./components/FertilityServices/TesaPesa.jsx";
import AdminLogin from "./AdminDashBoard/AdminLogin.jsx";
import CareerAdmin from "./AdminDashBoard/CareerAdmin.jsx";
import ContactAdmin from "./AdminDashBoard/ContactAdmin.jsx";
import UserSign from "./AdminDashBoard/UserSign.jsx";
import PatintDetail from "./AdminDashBoard/PatintDetail.jsx";
import InfertilityDoctors from "./components/Pages/InfertilityDoctors.jsx";
import InfertilityTreatmentDoctor from "./components/Pages/InfertilityTreatmentDoctor.jsx";
import ExpertIvfBlog from "./components/Pages/ExpertIVFTreatment.jsx";
import BestIVFDoctor from "./components/Pages/BestIVFDoctor.jsx";
import BestIVFDoctorinJabalpur from "./components/Pages/BestIVFDoctorinJabalpur.jsx";
import BestInfertilityDoctorInJabalpur from "./components/Pages/BestInfertilityDoctorInJabalpur.jsx";
import DifferenceBetweenIVFandIUITreatments from "./components/Pages/DifferenceBetweenIVFandIUITreatments.jsx";
import EggFreezinginJabalpur from "./components/Pages/EggFreezinginJabalpur.jsx";
import StrugglingwithInfertility from "./components/Pages/StrugglingwithInfertility.jsx";
import InfertilitySpecialistBlog from "./components/Pages/InfertilitySpecialistBlog.jsx";
import IVFTreatmentBlog from "./components/Pages/IVFTreatmentBlog.jsx";
import MaleInfertilityBlog from "./components/Pages/MaleInfertilityBlog.jsx";
import GynecologistBlog from "./components/Pages/GynecologistBlog.jsx";
import TreatmentOligospermia from "./components/Pages/TreatmentOligospermia.jsx";
import FertilitySolutionsforCouples from "./components/Pages/FertilitySolutionsforCouples.jsx";
import IVFandICSI from "./components/Pages/IVFandICSI.jsx";
import AdminBlogForm from "./AdminDashBoard/AdminBlogForm.jsx";
import AdminBlogList from "./AdminDashBoard/AdminBlogList.jsx";
import Blogs from "./components/Pages/Blogs.jsx";
import BlogDetail from "./components/Blogs/BlogDetail.jsx";
import BlogList from "./components/Pages/BlogList.jsx";
import { useSelector } from "react-redux";
import LandingPage from "./components/Pages/LandingPage.jsx";
function App() {
  const user = useSelector((state) => state.user);
  const { pathname } = useLocation();
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    localStorage.setItem("formSubmitted", "true");
  };

  const handleShow = () => setShowModal(true);

  useEffect(() => {
    if (
      !pathname.includes("/Admin-Page") &&
      pathname !== "/Admin-Login" &&
      pathname !== "/PatintDetail" &&
      pathname !== "/AdminAdd-blogs" &&
      pathname !== "/Updateblog/:id" &&
      pathname !== "/blogs/newAdd"
    ) {
      const timer = setTimeout(() => {
        handleShow();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleFormSubmit = () => {
    handleClose(); // Close the modal
  };

  return (
    <SmoothScrollWrapper>
      {/* <> */}
      {/* Render modal only if showModal is true */}
      {showModal && (
        <ModalComponent
          show={showModal}
          handleClose={handleClose}
          onSubmit={handleFormSubmit}
        />
      )}
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/landing-page" element={<LandingPage />} />
          <Route path="/doctors/:doctorId" element={<DoctorDetails />} />
          <Route path="/video-blogs" element={<Blog />} />
          <Route path="/blogs" element={<BlogList />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route
            path="/Best-Oligospermia-Treatment-in-Jabalpur"
            element={<BlogDetails />}
          />
          <Route
            path="/Best-Male-Infertility-Treatment-in-Jabalpur"
            element={<InfertilityDoctors />}
          />
          <Route
            path="/Best-Infertility-Treatment-Doctor-in-Jabalpur"
            element={<InfertilityTreatmentDoctor />}
          />
          <Route
            path="/Infertility-Treatment-Doctor-Jabalpur"
            element={<ExpertIvfBlog />}
          />
          <Route
            path="/Best-IVF-Doctor-in-Jabalpur-Dr.Archana-Shrivastav"
            element={<BestIVFDoctor />}
          />
          <Route
            path="/Dr.Archana-Shrivastav-Best-IVF-Doctor-in-Jabalpur-Madhya-Pradesh"
            element={<BestIVFDoctorinJabalpur />}
          />
          <Route
            path="/Best-Infertility-Doctor-in-Jabalpur-Dr.Archana-Shrivastav-Jabalpur-Fertility-Centre"
            element={<BestInfertilityDoctorInJabalpur />}
          />
          <Route
            path="/Difference-Between-IVF-and-IUI-Treatments-Best-IVF-Doctor-in-Jabalpur"
            element={<DifferenceBetweenIVFandIUITreatments />}
          />
          <Route
            path="/Struggling-with-Infertility-Meet-the-Best-IUI-Center-and-best-infertility-doctors-in-Jabalpur"
            element={<StrugglingwithInfertility />}
          />
          <Route
            path="/Egg-Freezing-in-Jabalpur-Best-Fertility-Treatment"
            element={<EggFreezinginJabalpur />}
          />
          <Route
            path="/Meet-the-Best-IVF-Doctor-and-Infertility-Specialist-in-Jabalpur"
            element={<InfertilitySpecialistBlog />}
          />
          <Route
            path="/IVF-Treatment-in-Jabalpur-Cost-Success-Rates-Best-Fertility-Clinic"
            element={<IVFTreatmentBlog />}
          />
          <Route
            path="/best-gynecologist-obstetrician-jabalpur"
            element={<GynecologistBlog />}
          />
          <Route
            path="/best-treatment-for-oligospermia"
            element={<TreatmentOligospermia />}
          />
          <Route
            path="/best-fertility-clinic-jabalpur-ivf-treatment"
            element={<FertilitySolutionsforCouples />}
          />
          <Route
            path="/can-not-conceive-naturally-IVF-and-ICSI-Might-Be-the-Key"
            element={<IVFandICSI />}
          />
          <Route path="/appointments" element={<Appointments />} />
          {/* <Route path="/departments" element={<Departments />} /> */}
          <Route
            path="/Male-Infertility-Treatment-in-Jabalpur-Meet-the-Best-Doctors-for-Fertility-Solutions"
            element={<MaleInfertilityBlog />}
          />
          <Route
            path="/departments/:departmentId"
            element={<DepartmentDetails />}
          />
          {/* <Route path="/pricing-plan" element={<PricingPlan />} /> */}
          <Route path="/gallery" element={<Gallery />} />
          {/* <Route path="/timetable" element={<Timetable />} /> */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/Solution" element={<Solution />} />
          <Route path="/Querise" element={<Querise />} />
          <Route path="/Review" element={<Review />} />
          <Route path="*" element={<ErrorPage />} />

          {/* Fertility Services */}
          <Route path="/Complete-Workup" element={<CompleteWorkup />} />
          <Route path="/Counselling" element={<Counselling />} />
          <Route
            path="/Egg-Or-Sperm-Donation"
            element={<EggOrSpermDonation />}
          />
          <Route path="/Embryo-Donation" element={<EmbryoDonation />} />
          <Route
            path="/Fertility-Preservation"
            element={<FertilityPreservation />}
          />
          <Route path="/Laparoscopy" element={<Laparoscopy />} />
          <Route path="/ICSI" element={<ICSI />} />
          <Route path="/IUI" element={<IUI />} />
          <Route path="/IVF" element={<IVF />} />
          <Route path="/Laparoscopy-Removal" element={<LaparoscopyRemoval />} />
          <Route path="/Tesa-Pesa" element={<TesaPesa />} />
          {/* End of Fertility Services */}
        </Route>

        {/* Admin routes */}
        <Route path="/Admin-Login" element={<AdminLogin />} />
        <Route
          path="/Admin-Page-Career"
          element={
            user?.currentUser === null ? <AdminLogin /> : <CareerAdmin />
          }
        />
        <Route
          path="/Admin-Page-Contact"
          element={
            user?.currentUser === null ? <AdminLogin /> : <ContactAdmin />
          }
        />
        <Route
          path="/Admin-Page-UserSign"
          element={user?.currentUser === null ? <AdminLogin /> : <UserSign />}
        />
        <Route
          path="/PatintDetail"
          element={
            user?.currentUser === null ? <AdminLogin /> : <PatintDetail />
          }
        />
        <Route
          path="blogs/newAdd"
          element={
            user?.currentUser === null ? <AdminLogin /> : <AdminBlogForm />
          }
        />
        <Route
          path="/AdminAdd-blogs"
          element={
            user?.currentUser === null ? <AdminLogin /> : <AdminBlogList />
          }
        />
        <Route
          path="Updateblog/:id"
          element={
            user?.currentUser === null ? <AdminLogin /> : <AdminBlogForm />
          }
        />
      </Routes>
    </SmoothScrollWrapper>
    // </>
  );
}

export default App;
